"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Arrowupright = function Arrowupright(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "ArrowuprightTitle ArrowuprightDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "ArrowuprightTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "ArrowuprightDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    fillRule: "evenodd",
    d: "M16.941 6h.02c.024 0 .05.002.074.004L16.94 6a1.067 1.067 0 0 1 .206.02l.021.004a1.051 1.051 0 0 1 .315.125l.084.055a1.063 1.063 0 0 1 .123.106l.008.009c.023.023.044.047.065.072l-.073-.08a.911.911 0 0 1 .096.11l.01.012.055.084a1.05 1.05 0 0 1 .15.543v7.059a1.059 1.059 0 0 1-2.118 0V9.614L7.808 17.69a1.059 1.059 0 0 1-1.498-1.498l8.075-8.075H9.882a1.059 1.059 0 1 1 0-2.117h7.06z"
  }));
};

Arrowupright.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Arrowupright.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Arrowupright;
exports["default"] = _default;